module.exports = __webpack_public_path__ + "static/media/webdesign-services-img35.7a243356.jpg";